import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * 🔹 Jayesh Sir, ye component har page change par
 * scroll ko reset karega taaki user hamesha top se shuru kare.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    try {
      // Modern browsers ke liye instant reset
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant",
      });
    } catch (error) {
      // Fallback agar 'instant' support na kare
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
